import { useEffect, useState } from 'react';

import { useAppSelector } from 'index';
import userManager from 'managers/userManager';

export function useIsUserPending(): boolean {
    const role = useAppSelector((state) => state.user.role);
    const [session, setSession] = useState<'checking' | 'signedIn' | 'signedOut'>('checking');

    useEffect(() => {
        userManager
            .getUser()
            .then((user) => setSession(user?.profile.role ? 'signedIn' : 'signedOut'))
            .catch(() => setSession('signedOut'));
    }, []);

    return session === 'checking' || (session === 'signedIn' && !role);
}
